import { BadRequestException } from '../services/exceptions'
import { get, post } from './http'

export async function addFavourite(entity) {
    const entityStr = JSON.stringify(entity)
    const response = await post(`/users/favourite/${encodeURIComponent(entityStr)}`)

    if (response.status === 200)
        return await response.json()

    throw new BadRequestException('Unknown error occured on addFavourite')
}

export async function deleteFavourite(category, _id) {
    const response = await post(`/users/deleteFavourite/${category}/${_id}`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException('Unknown error occured on deleteFavourite')
}

export async function getFavourites() {
    const response = await get(`/users/getFavourites`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function setUserAlertsConfig(obj) {
    // console.log('setUserAlertsConfig obj:',obj)
    const objStr = JSON.stringify(obj)
    const response = await get(`/users/setUserAlertsConfig/${encodeURIComponent(objStr)}`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function getUserAlertsConfig() {
    // console.log('getUserAlertsConfig ')
    const response = await get(`/users/getUserAlertsConfig`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}